module.exports = __webpack_public_path__ + "img/logo_sidebar.cb3f10b5.png";